// extracted by mini-css-extract-plugin
export default {"modCont":"ModalWindow_modCont__hE96g","darkBG_":"ModalWindow_darkBG___ElmvD","darkBG":"ModalWindow_darkBG__YS4KX","centered":"ModalWindow_centered__CRy4y"};